import { useEffect, useState } from "react"
import { getApp, getApps, initializeApp } from "firebase/app";
import {getDatabase, onChildAdded, push, ref} from "firebase/database";
import { firebaseConfig } from "../utils/constants";
import TextArea from "../shared/TextArea";
import NormalButton from "../shared/NormalButton";
import moment from "moment";
import MiniLoading from "../shared/MiniLoading";
import { useTranslation } from "react-i18next";

const Comments = ({resourceLable,resourceType='requests',resourceId=null,vendor=null}) => {
    const { t } = useTranslation();
    const label = resourceLable || t('comments.request');

    const [commentsList, setCommentsList] = useState([]);
    const [isCommentsFetched, setIsCommentsFetched] = useState(false);
    const [comment, setComment] = useState('');
    const [isAddCommentDisabled, setIsAddCommentDisabled] = useState(true);

    useEffect(()=>{
        if(!vendor?.username || !resourceId) return;
        const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
        const db = getDatabase(app);
        const commentsRef = ref(db, `vendors-${resourceType}-comments/${vendor?.username}/${resourceId}`);
        const unSubscribe = onChildAdded(commentsRef, (snapshot) => {
            setIsCommentsFetched(true);
            const data = snapshot.val();
            if(data) {
                setCommentsList((commentsList)=>[data,...commentsList]);
            }
        });


        return()=>{
            unSubscribe();
        }
    },[vendor?.username, resourceId])

    const setCommentAction = (message) => {
        setIsAddCommentDisabled(true);
        setComment('');
        const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
        const db = getDatabase(app);
        const commentsRef = ref(db, `vendors-${resourceType}-comments/${vendor?.username}/${resourceId}`);
        push(commentsRef,{
            message: message,
            createdAt: Date.parse(new Date())
        })
    }

    useEffect(()=>{
        if(comment && typeof comment === 'string' && comment.length > 4) {
            setIsAddCommentDisabled(false);
        } else {
            setIsAddCommentDisabled(true);
        }
    },[comment])

    useEffect(()=>{
        setTimeout(()=>{
            setIsCommentsFetched(true);
        },3000);
    },[])


    
    if (!resourceId || !vendor) return;

    return (
        <>
        <div className="h-[43px] bg-grey-200 text-center rounded-t-[8px] leading-[43px] text-grey-900 text-[18px] font-[700] mt-[24px]">{t('comments.commentsOn')} {label}</div>
        <div className="border-[1px] border-t-0 border-grey-200 rounded-b-[8px] overflow-hidden">
            {isCommentsFetched ? <>{((Array.isArray(commentsList) && commentsList.length > 0) ? commentsList?.map((comment,index)=>{
                return (<div key={`comment-${index}`} className="bg-darkBlue text-white px-[16px] rounded-[12px] m-[16px] p-[16px]">
                    <div className="font-bold">{comment?.message}</div>
                    <div className="text-end text-[12px] text-white/50">{moment(comment?.createdAt).format('DD/MM/YYYY HH:mm A')}</div>
                </div>)
            }) : <div className="text-center bg-white px-[16px] leading-[50px]">{t('comments.noCommentsOn')} {label}</div>)}
            <div className="p-[16px]">
                <TextArea placeholder={`${t('comments.writeCommentOn')} ${label} ${t('comments.onlyForYou')}`} value={comment} onChange={(e)=>{setComment(e.target.value)}} />
                <div className="text-end">
                    <NormalButton label={t('comments.add')} isDisabled={isAddCommentDisabled} onClick={()=>setCommentAction(comment)} />
                </div>
            </div></>
            : <div className="relative h-[100px] w-full bg-white">
                <MiniLoading />
            </div>
            }
            
        </div>
        </>
    )
}

export default Comments;